var _path, _mask, _g, _path2, _path3, _mask2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMiniSalonResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M15.187 25.15h3.49v-3.27h-4.13c.083 1.176.307 2.282.64 3.27zM14.511 20.633h4.165v-3.27H14.94c-.26 1.01-.411 2.115-.428 3.27zM18.677 29.312v-2.916h-2.984c.755 1.553 1.809 2.63 2.984 2.916zM25.337 20.633h2.68c-.026-1.158-.276-2.264-.715-3.27H24.96c.231 1.017.363 2.115.378 3.27zM15.329 16.117h3.348v-3.753c-1.376.337-2.591 1.756-3.348 3.753zM13.642 17.364H11.3c-.44 1.006-.689 2.11-.716 3.27h2.68c.015-1.157.148-2.253.378-3.27zM12.578 26.396c.849 1.026 1.932 1.85 3.16 2.401-.563-.659-1.053-1.466-1.444-2.4h-1.716zM13.292 21.88h-2.65c.14 1.178.517 2.282 1.08 3.27h2.138c-.296-1.004-.496-2.1-.568-3.27zM15.739 12.88c-1.547.694-2.854 1.825-3.767 3.237h2.01c.427-1.29 1.031-2.39 1.757-3.238zM19.924 26.396v2.916c1.175-.287 2.23-1.364 2.984-2.916h-2.984zM22.863 28.797c1.229-.552 2.311-1.375 3.16-2.4h-1.716c-.39.934-.88 1.742-1.444 2.4zM24.74 25.15h2.139c.564-.987.94-2.092 1.08-3.27h-2.65c-.072 1.17-.273 2.267-.568 3.27zM24.055 21.88h-4.13v3.27h3.49c.332-.989.556-2.095.64-3.27zM19.924 12.364v3.753h3.348c-.757-1.997-1.97-3.415-3.348-3.753zM26.63 16.117c-.913-1.412-2.22-2.543-3.767-3.238.725.85 1.33 1.949 1.757 3.238h2.01zM23.663 17.364h-3.739v3.27h4.166c-.016-1.156-.168-2.26-.427-3.27zM28.914 15.988c-.361 0-.655-.293-.655-.654v-3.118c0-.361.294-.655.655-.655.36 0 .654.294.654.655v3.118c0 .36-.293.654-.654.654z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a7mxjo3mka",
    width: 6,
    height: 2,
    x: 26,
    y: 13,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26.701 13.12h4.425v1.31h-4.425v-1.31z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a7mxjo3mka)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M30.472 14.43h-3.116c-.362 0-.655-.294-.655-.655 0-.362.293-.655.655-.655h3.116c.361 0 .655.293.655.655 0 .361-.294.655-.655.655z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M10.213 31.328c-.361 0-.655-.294-.655-.655v-3.117c0-.362.294-.654.655-.654.36 0 .654.292.654.654v3.117c0 .361-.293.655-.654.655z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M11.771 29.769H8.655c-.362 0-.655-.293-.655-.655 0-.362.293-.654.655-.654h3.116c.361 0 .655.292.655.654 0 .361-.294.655-.655.655z",
    clipRule: "evenodd"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "g0kusbqgtb",
    width: 24,
    height: 24,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8 31.328h23.126V8H8v23.328z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#6C7281",
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#g0kusbqgtb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.647 11.771h1.308V8.654h-1.308v3.117z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.859 9.31h-3.116c-.362 0-.654-.294-.654-.655 0-.363.292-.655.654-.655h3.116c.36 0 .654.292.654.655 0 .36-.293.654-.654.654z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiniSalonResting);
export default __webpack_public_path__ + "static/media/icon_mini_salon_resting.2a91cab4946b94db46205e73d891ee2e.svg";
export { ForwardRef as ReactComponent };